// Turn an ISO date / datetime string into a human-readable label, formatted in UTC so a
// midnight-UTC date (e.g. "2026-07-13T00:00:00.000Z") doesn't shift a day in the local timezone.
// Returns null when the input isn't an ISO date string, so callers can fall through to their
// default rendering.
const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2})?(\.\d+)?(Z|[+-]\d{2}:?\d{2})?)?$/;

export function formatIsoDate(value: unknown): string | null {
  if (typeof value !== 'string' || !ISO_DATE_RE.test(value)) return null;
  const d = new Date(value);
  if (isNaN(d.getTime())) return null;
  const date = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
  // Include the time only when it isn't midnight UTC (i.e. a real timestamp, not a plain date).
  const hasTime = d.getUTCHours() !== 0 || d.getUTCMinutes() !== 0;
  if (!hasTime) return date;
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
  return `${date}, ${time}`;
}
